import { AUTHOR_CHANGED, CATEGORY_CHANGED, SEARCH_BLOGS } from "./actionTypes";

export const authorChanged = (name) => {
  return {
    type: AUTHOR_CHANGED,
    payload: name,
  };
};

export const categoryChanged = (category) => {
  return {
    type: CATEGORY_CHANGED,
    payload: category,
  };
};

export const searchBlogs = (text) => {
  return {
    type: SEARCH_BLOGS,
    payload: text,
  };
};
